import { IFlatCoords } from "./sharedTypes";
import { IGcpAppDispatch } from "../../redux/store";
import { performSignedRequest } from "../../redux/modules/auth/asyncActions";
import config from "../../config";
import { ISRS } from "../csu/site";

export interface IFlightMarker {
  id: string;
  name: string;
  operatorName: string;
  operatorCoords: IFlatCoords;
  tsCreated: number;
  archivedBy: string | null;
  tsArchived: number | null;
  isQC: boolean;
  comment: string | null;
  commentedBy: string | null;
  tsCommented: number | null;
}

export const fetchFlightMarkers =
  (customerId: string, siteId: string) =>
  async (dispatch: IGcpAppDispatch): Promise<IFlightMarker[]> => {
    const bapiResponse = await dispatch(
      performSignedRequest(
        {
          method: "GET",
          url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/flight-markers`,
        },
        customerId,
        siteId,
      ),
    );
    return bapiResponse.data.flightMarkers;
  };

export const updateFlightMarkers =
  (
    customerId: string,
    siteId: string,
    flightMarkers: IFlightMarker[],
    srs: ISRS,
  ) =>
  async (dispatch: IGcpAppDispatch): Promise<void> => {
    await dispatch(
      performSignedRequest(
        {
          method: "POST",
          url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/flight-markers`,
          data: {
            srs,
            flightMarkers,
          },
        },
        customerId,
        siteId,
      ),
    );
  };
